import React from 'react';
import { Image } from 'react-bootstrap';
import Diet from '../Images/DietPlan Banner.png';
import './Nutrition.css';

function DietPlan() {
  return (
    <div className="bg-page">
      <Image src={Diet} fluid className="Banner-Img" />

      <div className="form-section">
        <div className="form-wrapper">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSfo-gkIHHmtIMTaPD2lkroyquANV-4EORiLkmRncWMZa62cVQ/viewform?embedded=true"
            className="google-form"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Nutrition Form"
          >
            Loading...
          </iframe>
        </div>
      </div>
    </div>
  );
}

export default DietPlan;